import './getting-started.scss';

import * as gzStart from './getting-started.directive';

import gazelleAnalytics from '../../core/analytics/analytics.module';

export default angular.module('gazelle.components.start', [
  'pascalprecht.translate',
  'rhino.components.preferences',
  'rhino.core',
  gazelleAnalytics
])
  .directive(gzStart.name, gzStart.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/getting-started/getting-started.module.js